/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadPccPatientDetailsRequest
 */
export interface UploadPccPatientDetailsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UploadPccPatientDetailsRequest
     */
    push_summary_report: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UploadPccPatientDetailsRequest
     */
    push_screener_results: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UploadPccPatientDetailsRequest
     */
    push_clinic_package: boolean;
}

/**
 * Check if a given object implements the UploadPccPatientDetailsRequest interface.
 */
export function instanceOfUploadPccPatientDetailsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "push_summary_report" in value;
    isInstance = isInstance && "push_screener_results" in value;
    isInstance = isInstance && "push_clinic_package" in value;

    return isInstance;
}

export function UploadPccPatientDetailsRequestFromJSON(json: any): UploadPccPatientDetailsRequest {
    return UploadPccPatientDetailsRequestFromJSONTyped(json, false);
}

export function UploadPccPatientDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadPccPatientDetailsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'push_summary_report': json['push_summary_report'],
        'push_screener_results': json['push_screener_results'],
        'push_clinic_package': json['push_clinic_package'],
    };
}

export function UploadPccPatientDetailsRequestToJSON(value?: UploadPccPatientDetailsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'push_summary_report': value.push_summary_report,
        'push_screener_results': value.push_screener_results,
        'push_clinic_package': value.push_clinic_package,
    };
}

